import FormHelperText from '@mui/material/FormHelperText'
import InterestLevelPicker from 'Components/reusable/InputFields/InterestLevelPicker'
import { useContext } from 'react'
import { ISkillInterestLevel } from 'types/levelItemInterfaces'
import { Context } from '../context'
import { AnyObject, ContextValue, EditableFieldsOfType } from '../types'

/**
 * Checkbox / switch field.
 */
export const DataEditContextInterestLevelField = <T extends AnyObject>({
  field,
  ...rest
}: {
  field: EditableFieldsOfType<T, ISkillInterestLevel | null>
} & Omit<Record<string, unknown>, 'onChange' | 'value' | 'error' | 'name'>) => {
  const { flatData, errors, disabled, setFields } = useContext<ContextValue<T>>(Context)

  const handleChange = (newValue: ISkillInterestLevel | null) => {
    setFields({ [field]: newValue as unknown as ISkillInterestLevel })
  }

  const value = flatData[field] as unknown as ISkillInterestLevel
  const error = errors[field]

  return (
    <>
      <InterestLevelPicker value={value} disabled={disabled[field]} onChange={handleChange} {...rest} />
      {error && <FormHelperText>{error}</FormHelperText>}
    </>
  )
}

/**
 * Markdown editor.
 */
